import { useCallback } from "react";
import Adtrace from "web-adtrace";

export function useAdtraceEvent() {
    /**
     * Track an Adtrace event
     * @param eventToken - The event token from Adtrace dashboard
     * @param params - Optional params like revenue, currency, callback params
     */
    const trackEvent = useCallback(
        (eventToken: string, params: Record<string, any> = {}) => {
            if (!eventToken) {
                console.warn("Adtrace eventToken is required");
                return;
            }
            Adtrace.trackEvent({
                eventToken,
                ...params,
            });
        },
        []
    );

    return { trackEvent };
}
